import React from "react";
import { Link } from "react-scroll";
import "./Intro.scss";

const Intro = ({ selectNav, componentOffsetTop }) => {
  return (
    <div
      id="intro"
      className="intro animate__animated animate__fadeIn"
      ref={(e) => (componentOffsetTop.current[0] = e)}
    >
      <div className="introduce">
        <div>
          <p>Hi,</p>
          <p>I'm Meisam</p><h2 style={{ color: '#808080'}}>(Erwin)</h2>
          <p>Full Stack Web Developer</p>
          <Link
            className="link-portfolio"
            onClick={() => selectNav("PROJECTS")}
            to="projects"
            offset={0}
            containerId="body"
            smooth={true}
            duration={1000}
          >
            <p>
              Look at my Profile  <i className="fas fa-briefcase"></i>{" "}
            </p>
          </Link>
        </div>
      </div>
      <div className="photo-container">
        <div>
          <img src="./Profile-pic.jpg" alt="Erwin"></img>
        </div>
      </div>
    </div>
  );
};

export default Intro;
